import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { Subscription } from 'rxjs';
import { RepliesFilter, Question } from '../../../../../classes';
import { RepliesService } from '../../../../../services';

@Component({
  selector: 'app-question-filter',
  templateUrl: './question-filter.component.html',
  styleUrls: ['./question-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class QuestionFilterComponent implements OnInit {
  @Input() question: Question;
  subscription = new Subscription();
  filter: RepliesFilter;
  constructor(
    private repliesService: RepliesService,
    private cdRef: ChangeDetectorRef
  ) {
    this.filter = this.repliesService.filter;
  }
  ngOnInit() {
    this.subscription.add(this.filter.onChange.subscribe(()=>this.cdRef.detectChanges()));
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();    
  }
  isFilterOn () {
    return this.question.options.find(o=>this.filter.getOptionShould(o) ? true : false) ? true : false ;
  }
}
